import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../../context/auth";
import { ImpporSector } from "./modalImpPpsector";
import TablaPP from "./tablaPP";
import axios from "axios";
import TablaClasepp from "./tablaClasePP";
import TablaDeudaspp from "./tablaConsultaDeuda";
import { ImpporDeuda } from "./modalImpPpDeuda";
import { ConfiguracionModuloPP } from "./modalConfiguracionModuloPP";
import TablaUsuarioPro from "./tablaUsuarioPropaganda";

import Menu from "../../comun/Menu/Menu.jsx";
import Item from "../../comun/Menu/Item.jsx";
function MenuImpuestoPP() {
  const { user } = useContext(AuthContext);

  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");
  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    if (obj != null) {
    } else {
    }
  }, []);

  const actualizacionItem = {
    title: "Actualizacion",
    icon: "fa fa-pen me-2",
    drop: [
      // {
      //   title: "Registro de contribuyentes",
      //   icon: "fa fa-user-plus me-2",
      //   itemClickValue: 1,
      // },
      {
        title: "Clasificador de publicidad",
        icon: "fa fa-pen-square me-2",
        itemClickValue: 2,
      },
      {
        title: "Estados de cuenta",
        icon: "fas fa-address-card me-2",
        itemClickValue: 3,
      },
    ],
  };

  const imprimirItem = {
    title: "Imprimir",
    icon: "fa fa-print me-2",
    drop: [
      {
        title: "General por sector",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 4,
      },
      {
        title: "Contribuyentes con deudas",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 5,
      },
      {
        title: "Tipo de publicidad/ordenanza",
        icon: "fa fa-file-powerpoint me-2",
        itemClickValue: 6,
      },
    ],
  };

  const configuracionItem = {
    title: "Configuracion",
    icon: "fa fa-cog me-2",
    drop: [
      {
        title: "Configuración General",
        icon: "fa fa-screwdriver me-2",
        itemClickValue: 7,
      },
      {
        title: "Usuarios",
        icon: "fa fa-user me-2",
        itemClickValue: 8,
      },
    ],
  };

  const [tabla, setTabla] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (tabla === 6) {
      const reporte = "ListTipoPubl";
      window.open(
        op.reportes + "/propagandapublicidad?" + "reporte=" + reporte,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    }
  }, [tabla]);

  const PorDefecto = () => {
    const azulProfundo = "#003a70";
    const azulVibrante = "#007bff";

    return (
      <section
        className="col-12 m-0 p-0"
        style={{ height: "90dvh", overflow: "hidden" }}
      >
        <style>{`
          @keyframes float {
            0% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
            50% { transform: translateY(-20px) translateX(10px); opacity: 1; }
            100% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
          }
          .tech-dot {
            position: absolute;
            background: white;
            border-radius: 50%;
            animation: float 6s infinite ease-in-out;
          }
        `}</style>

        <div
          className="col-md-12 row mx-auto px-0"
          style={{ minHeight: "100%" }}
        >
          <div
            className="col-md-6 d-flex justify-content-center align-items-center"
            style={{
              position: "relative",
              left: "-50px",
              borderBottomRightRadius: "30%",
              height: "90dvh",
              backgroundColor: azulProfundo,
              overflow: "hidden",
              boxShadow: "10px 0 30px rgba(0,0,0,0.2)",
            }}
          >
            {/* 1. FONDO MESH GRADIENT (Profundidad) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: `
                radial-gradient(circle at 20% 30%, ${azulVibrante} 0%, transparent 50%),
                radial-gradient(circle at 80% 70%, #00d4ff 0%, transparent 50%),
                ${azulProfundo}
              `,
              }}
            />

            {/* 2. REJILLA TECNOLÓGICA (Grid lines) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage: `linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), 
                                linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)`,
                backgroundSize: "50px 50px",
              }}
            />

            {/* 3. PUNTOS ANIMADOS (Partículas) */}
            <div
              className="tech-dot"
              style={{
                width: "6px",
                height: "6px",
                top: "20%",
                left: "15%",
                animationDelay: "0s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "4px",
                height: "4px",
                top: "60%",
                left: "25%",
                animationDelay: "1s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "8px",
                height: "8px",
                top: "40%",
                left: "80%",
                animationDelay: "2s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "3px",
                height: "3px",
                top: "80%",
                left: "60%",
                animationDelay: "1.5s",
              }}
            />

            {/* 4. RÁFAGAS DE LUZ DIAGONALES */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 20%, rgba(255,255,255,0.05) 50%, transparent 100%)",
                transform: "skewX(-20deg)",
              }}
            />

            {/* LOGO CON GLOW */}
            <div
              style={{ position: "relative", zIndex: 10, textAlign: "center" }}
            >
              {/* <img
                style={{
                  filter: "drop-shadow(0px 0px 30px rgba(255,255,255,0.3))",
                  maxWidth: "100%",
                  transition: "transform 0.3s ease",
                }}
                className="img-fluid"
                src={op.imagenes + "/imagen?img=" + op.logohacienda}
                alt="Logo SIAP"
              /> */}
              <h3 style={{
              position: 'relative', // Cambiado de absolute a relative para trabajar con flexbox
              fontSize: '40px',
              color: '#ffffff',
              textAlign: 'center', // Asegura que el texto esté centrado
              width: '100%' // Ocupa todo el ancho disponible
            }}>PROPAGANDA <br/> Y PUBLICIDAD</h3>
            </div>
          </div>

          {/* LADO DERECHO (Alcaldía) */}
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <img
              className="img-fluid px-5"
              src={op.imagenes + "/imagen?img=" + op.logohacienda}
              alt="Logo Alcaldía"
              style={{ maxWidth: "85%" }}
            />
          </div>
        </div>
      </section>
    );
  };
  const vista = {
    0: <TablaPP />,
    1: <TablaPP setTabla={setTabla} />,
    2: <TablaClasepp setTabla={setTabla} />,
    3: <TablaDeudaspp setTabla={setTabla} />,
    4: <ImpporSector show={show} setShow={setShow} tabla={tabla} />,
    5: <ImpporDeuda show={show} setShow={setShow} tabla={tabla} />,
    6: "",
    7: <ConfiguracionModuloPP show={show} setShow={setShow} />,
    8: <TablaUsuarioPro setTabla={setTabla} />,
  };

  return (
    user && (
      <div>
        <Menu fechaSistema={fechaSistema} op={op} show={() => setTabla(0)}>
          <Item
            item={actualizacionItem}
            setTabla={setTabla}
            setShow={setShow}
          />
          <Item item={imprimirItem} setTabla={setTabla} setShow={setShow} />
          <Item
            item={configuracionItem}
            setTabla={setTabla}
            setShow={setShow}
          />
          <a
            href="/haciendaMunicipal"
            className="list-group-item list-group-item-action bg-transparent text-danger fw-bold"
          >
            <i className="fas fa-power-off me-2" />
            Salir
          </a>
        </Menu>
        <section className="col-12 m-0 p-0 d-flex align-items-center justify-content-center" style={{ height: '100dvh' }}>
          {vista[tabla]}
        </section>
      </div>
    )
  );
}
export default MenuImpuestoPP;
